import React, { useRef } from 'react';
import { MAX_DOCUMENTS, ROW_STATES, slotsUsed } from './documentUpload';
import { rowLabel } from './documentStatusUpdates';

const ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.aac,.mp3,.wav,.m4a,.amv,.mpeg,.mpg,.flv';

export default function DocumentUploadArea({ rows, refused, onAddFiles, onRemove, onReplace, disabled, connectionState }) {
    const addInput = useRef(null);
    const replaceInputs = useRef({});
    const full = slotsUsed(rows) >= MAX_DOCUMENTS;

    return (
        <div className="raise-enquiry__documents" id="raise-enquiry-documents">
            <h2 className="raise-enquiry__question">Add documents (optional)</h2>
            <p className="raise-enquiry__hint" id="raise-enquiry-documents-hint">
                {`Attach up to ${MAX_DOCUMENTS} files, each up to 10 MB: PDF, Word, Excel, text, image or audio files. Please attach files separately rather than in a zip. We check every file for viruses; you can send your enquiry while the checks run.`}
            </p>
            <input
                ref={addInput}
                type="file"
                multiple
                accept={ACCEPT}
                className="raise-enquiry__documents-input"
                id="raise-enquiry-documents-input"
                onChange={(ev) => {
                    onAddFiles(ev.target.files);
                    ev.target.value = '';
                }}
            />
            <button
                type="button"
                className="raise-enquiry__documents-add"
                id="raise-enquiry-documents-add"
                disabled={disabled || full}
                onClick={() => addInput.current && addInput.current.click()}
            >
                Choose files
            </button>
            {refused.length > 0 && (
                <ul className="raise-enquiry__documents-refused" id="raise-enquiry-documents-refused">
                    {refused.map((item, index) => (
                        <li key={`${item.fileName}-${index}`} id={`raise-enquiry-documents-refused-${index}`}>
                            <strong>{item.fileName}</strong>: {item.message}
                        </li>
                    ))}
                </ul>
            )}
            {rows.length > 0 && (
                <ul className="raise-enquiry__documents-list" id="raise-enquiry-documents-list">
                    {rows.map((row, index) => (
                        <li
                            key={row.key}
                            className={`raise-enquiry__document raise-enquiry__document--${row.state}`}
                            id={`raise-enquiry-document-${index}`}
                        >
                            <span className="raise-enquiry__document-name" id={`raise-enquiry-document-${index}-name`}>
                                {row.fileName}
                            </span>
                            <span className="raise-enquiry__document-status" id={`raise-enquiry-document-${index}-status`}>
                                {rowLabel(row, connectionState)}
                                {row.state === ROW_STATES.UPLOADING && typeof row.progress === 'number' ? ` ${row.progress}%` : ''}
                            </span>
                            {row.state === ROW_STATES.UPLOADING && (
                                <span className="raise-enquiry__document-progress" id={`raise-enquiry-document-${index}-progress`}>
                                    <span
                                        className="raise-enquiry__document-progress-bar"
                                        id={`raise-enquiry-document-${index}-progress-bar`}
                                        style={{ width: `${row.progress || 0}%` }}
                                    />
                                </span>
                            )}
                            <span className="raise-enquiry__document-actions" id={`raise-enquiry-document-${index}-actions`}>
                                {row.state !== ROW_STATES.UPLOADING && (
                                    <>
                                        <input
                                            ref={(element) => {
                                                replaceInputs.current[row.key] = element;
                                            }}
                                            type="file"
                                            accept={ACCEPT}
                                            className="raise-enquiry__documents-input"
                                            id={`raise-enquiry-document-${index}-replace-input`}
                                            onChange={(ev) => {
                                                onReplace(row, ev.target.files && ev.target.files[0]);
                                                ev.target.value = '';
                                            }}
                                        />
                                        <button
                                            type="button"
                                            className="raise-enquiry__cancel"
                                            id={`raise-enquiry-document-${index}-replace`}
                                            disabled={disabled}
                                            onClick={() => replaceInputs.current[row.key] && replaceInputs.current[row.key].click()}
                                        >
                                            Replace
                                        </button>
                                    </>
                                )}
                                <button
                                    type="button"
                                    className="raise-enquiry__cancel"
                                    id={`raise-enquiry-document-${index}-remove`}
                                    disabled={disabled}
                                    onClick={() => onRemove(row)}
                                >
                                    Remove
                                </button>
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
